<template>
    <v-card>
    <v-container>
        <template>
            <div class="text-center">
                <v-btn :disabled="btn1" type="button" color="primary" @click="multiple">Carga multiple</v-btn>
                <v-btn :disabled="btn2" type="button" color="primary" @click="manual" >Carga Manual</v-btn>
            </div>
        </template>
    </v-container>
    
    <v-container fluid >
    <v-card :disabled="accion">
      <form ref="form"
    v-model="valid"
    lazy-validation
    >
      <v-spacer></v-spacer>
      <v-row align="end" style="height: 150px">
        <v-col  cols="12" sm="6" md="3">
          <v-container>
            <template>
              <v-file-input v-model="editedItem.files"
                    accept=".xlsx"
                    label="Archivo excel"
                    placeholder="Seleccione su archivo"
                    name="file"  
                    id="file"
                ></v-file-input>
                </template>
            </v-container>
            </v-col>
              <v-col align-self="center" cols="12" sm="6" md="4">
                <v-btn :disabled="editedItem.files.length == 0" color="primary" @click="carga">Cargar</v-btn>
                
              </v-col>
        </v-row>
    </form>  
    <v-spacer></v-spacer>
    </v-card>
    </v-container>
    <v-container fluid>
      <v-card :disabled="accion2" >
      <template>
        <v-form>
          <v-row >
            <v-col cols="12" sm="6" md="3">
              <v-container>
                <v-autocomplete v-model="editedItem.ApiEan"
                  :items="productbarcode"
                  :item-text="'ProductBarCode_Description'"
                  :item-value="'ProductBarCode_id'"
                  label="EAN - Descripción"
                 
                ></v-autocomplete>
                </v-container>
              </v-col>
              <v-col align-self="center" cols="12" sm="6" md="4">
                <v-btn :disabled="editedItem.ApiEan.length == 0" color="primary" @click="Agregar">Cargar</v-btn>
              </v-col>
             </v-row>
        </v-form>
      </template>
        <v-spacer></v-spacer>

      </v-card>
      </v-container>
      <v-spacer></v-spacer>
    <v-form>  
    <v-container fluid class="px-0">
      <v-card>
        <v-card-title>
        <v-icon x-large></v-icon>Productos
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
        <v-data-table
          :headers="headers"
          :items="mvm"
          :search="search"
          sort-by="calories"
          class="elevation-1"
        >
      </v-data-table>
      </v-card>
    </v-container>
    </v-form>  
    <template>
    <div class="text-center">
        <v-btn :disabled="btn3" type="button" color="primary" @click="onexport">Descargar Resultados Duplicados</v-btn>
    </div>
    
    </template>
      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
             <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
                <small>{{this.step_txt2}}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>  
        </v-stepper>
      </v-dialog>
      </v-card>
    </template>
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";
    //import JsonExcel from "vue-json-excel";
    import XLSX from 'xlsx';
     
    //Vue.component("downloadExcel", JsonExcel);
    
    export default {
      data: () => ({
        
        search: '',
        search2: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialog_pass: false,
        dialog_new: false,
        dialog_detail: false,
        valid: true,
        accion: true,
        accion2: true,
        btn1: false,
        btn2: false,
        btn3: true,
        menu: false,
        menu2: false,
        e1: 0,
        btnap:true,
        btn: false,
        msj_proceso:'',
        progressBar1: false,
        progressBar: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        RequestProposal_id:'',
        step_txt1:'',
        step_txt2:'',
        TurningStorageArea_id:'',
        TurningStorageArea_Desc:'',
        OpPoint_id: '',
        Supplier_Description:'',
        VendorPurchaseOrder_Num:'',
        Section_id:'',
        LastOpRepUser_id: '',
        RepEvent_Dttm: '',
        ApiUser_GivenName:'',
        status:'',
        CDay_id:'',
        CHour_Description:'',
        DateMvm:'',
        id_process:'',
        ProductBarcode_id:'',
        Product_id:'',
        headers: [
          { text: 'EAN', value: 'ProductBarCode_id' },
          { text: 'EAN Descripcion', value: 'ProductBarCode_Description' },
          { text: 'SKU', value: 'Product_id' },
          { text: 'Usuario', value: 'LastOpRepUser_id' },
          { text: 'Fecha', value: 'RepEvent_Dt' },
          { text: 'Hora', value: 'RepEvent_Tm' },

                    
        ],
        productbarcode: [{ ProductBarcode_id: '', ProductBarCode_Description: '' }],
        mvm: [],
        tdetalle: [],
        seleccion:[],
        RequestMVM: ['Propuesta ID', 'Número de Orden', 'Punto', 'Almacen ID', 'Almacén', 'Proveedor', 'R Social', 'Sección id', 'Fecha del Turno', 'Hora del Turno', 'status', 'Usuario id', 'Nombre de Usuario', 'Fecha de Cambio'],
        tdetalle_vew: [],
        editedIndex: -1,
        editedItem: {
          fecha: new Date().toISOString().substr(0, 10),
          files: [],
          ApiEan: ''
        },
        
        fechaRule: [
            v => !!v || 'Fecha es requerida'
        ],
        datoRule: [
            v => !!v || 'El dato es Requerido'
           
        ],
        
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      computed: {
        formTitle () {
          return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
        }
      },
    
      watch: {
        dialog (val) {
          val || this.close()
        }
      },
    
      created () {
        this.initialize()
      },
    
      methods: {
        initialize () {

          
          /* axios.post(this.api_tool_url + '/get_planning', this.editedItem, this.config)
            .then(response => {
                this.mvm = response.data.ResultRows
                 if(response.data.ResultRows.length >= 1)
                 {
                     axios.post(this.api_tool_url + '/get_planning_detail', this.editedItem, this.config)
                        .then(response => {
                            this.tdetalle = response.data.ResultRows
                        })
                        .catch(error => {
                            this.tdetalle = []
                            alert(error.response.data.message)
                        })
                 }
            })
            .catch(error => {
              this.mvm = []
              alert(error.response.data.message)
            }), */
          
            
        },
    
        carga() {
                this.btn = true
                this.step_txt1="Cargando EANs"
                this.step_txt2="Procesando"
                this.dialog_new = true
                this.e1 = 1
                this.progressBar = true
                this.step_error1 = true
                this.step_error2 = true
                this.step_error3 = true
                this.btnap=true
                this.step_color1 = "primary",
                this.step_color2 = "primary",
                this.step_color3 = "primary",
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                let data = new FormData();
                this.mvm = []
                data.append('foo', 'bar');
                data.append('file', document.getElementById('file').files[0]);
                //data.append('email', sessionStorage.getItem('ApiUser_EMail'));
                data.append('user', sessionStorage.getItem('ApiUser_id'));
                
      
     
                axios.post(this.api_tool_url + '/fileUpload_MaestroInsumos', data, this.config)
                .then(response => {
                        //if(response.data.ResultRows.length >= 1) {
                        if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {
                            if(response.data.status == "noOk")
                            {
                              this.mvm = response.data.existentes
                              this.e1 = 1
                              this.step_color1 = "#C0392B"
                              this.progressBar = false
                              this.msj_proceso = response.data.ResultRows
                              this.btn = false
                              this.active = false  
                              this.btn2 = false
                              this.accion = true
                              this.btn3 = false
                              this.editedItem.files = ''
                            }
                            else{
                              this.mvm = response.data.status
                              this.e1 = 1
                              this.step_color1 = "#008000"
                              this.progressBar = false
                              this.msj_proceso = 'Se realizo la carga correctamente.'
                              this.btn = false
                              this.active = false  
                              this.btn2 = false
                              this.accion = true
                              this.editedItem.files = ''
                              this.btn3 = true
                            }
                            
                        }
                        else {
                            this.e1 = 1
                            this.step_color1 = "#C0392B"
                            this.progressBar = false
                            this.msj_proceso = error.response.data.message
                            this.btn = false
                            this.active = true
                            this.btn2 = false
                            this.accion = true
                            this.editedItem.files = ''
                            this.btn3 = true
                        }
                        this.btn = false
                    })
                    .catch(error => {
                        this.btn = false
                        this.step_error1 = false
                        this.progressBar = false
                        this.msj_proceso = error.response.data.message
                        this.active = true
                        this.btn2 = false
                        this.accion = true
                        this.btn3 = true
                    })
                    
                    
              },
        Agregar(){
          
          this.btn = true
          this.step_txt1="Cargando EAN"
          this.step_txt2="Procesando"
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.btnap=true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          let ean = this.first
          let sku = this.last
          let currentDate = new Date().toISOString().substr(0, 10)
          let filtro = {
            ProductBarcode_id: this.editedItem.ApiEan, 
            LastOpRepUser_id: sessionStorage.getItem('ApiUser_id'),
            TS_LOAD: currentDate
          }
          
          axios.post(this.api_tool_url + '/insert_MaestroInsumos', filtro, this.config)
          .then(response => {
                  //if(response.data.ResultRows.length >= 1) {
                  if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {
                      if(response.data.status == "noOk")
                      {
                        this.e1 = 1
                        this.step_color1 = "#C0392B"
                        this.progressBar = false
                        this.msj_proceso = response.data.ResultRows
                        this.btn = false
                        this.active = true
                        this.btn1 = false
                        this.btn2 = false
                        this.accion = true
                        this.accion2 = true
                        this.btn3 = true
                        this.editedItem.ApiEan = ''
                        this.mvm = []
                      }
                      else
                      {
                        this.mvm = response.data.status
                        this.e1 = 1
                        this.step_color1 = "#008000"
                        this.progressBar = false
                        this.msj_proceso = 'Se realizo la carga correctamente.'
                        this.btn = false
                        this.active = false  
                        this.btn1 = false
                        this.btn2 = false
                        this.accion = true
                        this.accion2 = true
                        this.editedItem.ApiEan = ''
                        this.btn3 = true
                      }

                  }
                  else {
                      this.e1 = 1
                      this.step_color1 = "#C0392B"
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                      this.btn = false
                      this.active = true
                      this.btn1 = false
                      this.btn2 = false
                      this.accion = true
                      this.accion2 = true
                      this.btn3 = true
                  }
                  this.btn = false
              })
              .catch(error => {
                  this.btn = false
                  this.step_error1 = false
                  this.progressBar = false
                  this.msj_proceso = error.response.data.message
                  this.active = true
                  this.btn1 = false
                  this.btn2 = false
                  this.accion = true
                  this.accion2 = true
                  this.btn3 = true
              })


        },
        
        close() {
            this.dialog_new = false
        },    
        
    
        close () {
          this.dialog_new = false
        },
        close2 () {
          this.dialog_detail= false
        },
        manual(){
          this.valid = true
          this.accion2 = false
          this.btn1 = true
          this.step_txt1="Buscando lista de Productos"
          this.step_txt2="Consultando"
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.btnap=true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          axios.post(this.api_tool_url + '/get_EANs', {}, this.config)
          .then(response => {

            if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                this.productbarcode = response.data.ResultRows
                this.e1 = 1
                this.step_color1 = "#008000"
                this.progressBar = false
                this.msj_proceso = 'Ya puede realizar la seleccion del EAN a insertar.'
                this.btn = false
                this.active = false  
            }
            else {
                this.e1 = 1
                this.step_color1 = "#C0392B"
                this.progressBar = false
                this.msj_proceso = error.response.data.message
                this.btn = false
                this.active = true
            }
            
            /*this.productbarcode.push({ OpPoint_id: '', OpPoint_Description: '-Todos' })*/
          })
          .catch(error => {
            this.productbarcode = []
            alert(error.response.data.message)
            this.btn = false
            this.step_error1 = false
            this.progressBar = false
            this.msj_proceso = error.response.data.message
            this.active = true
            this.accion2 = true

          })
        },
        multiple(){
          this.accion = false
          this.btn2 = true
          this.btn3 = true
          

        },
        onexport () { // On Click Excel download button
        
          // export json to Worksheet of Excel
          // only array possible
          const header_r_f = ['EAN'];
          const header_r = ['ProductBarCode_id'];
          var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
          
    
          var range = XLSX.utils.decode_range(resumenWS['!ref']);
          for(var C = range.s.c; C <= range.e.c; ++C) {
            var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            resumenWS[colum].v = header_r_f[C];
          }
    
          range.e['c'] = header_r_f.length - 1;
          resumenWS['!ref'] = XLSX.utils.encode_range(range);
    
    
          // A workbook is the name given to an Excel file
          var wb = XLSX.utils.book_new() // make Workbook of Excel
    
          // add Worksheet to Workbook
          // Workbook contains one or more worksheets
          XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
          //XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
            
          var file='Listado_EANs_duplicados.xlsx';
    
          // export Excel file
          XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
          this.btn3 = true
        },
        
        close() {
            this.dialog_new = false
        },
      }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/SupplyProducts.vue